import DiagnosisQuestionTemplate from '~/pages/anatomyV2/libs/components/DiagnosisQuestionTemplate'
import { DIAGNOSIS_CORRECT_ANSWERS } from '~/pages/anatomyV2/libs/diagnosisCorrectAnswers'
import { PageId } from '~/shared/constants/pagesConstants'
import { TPageProps } from '~/shared/types/commonTypes'

const SECTION_NUMBER = 5

const DiagnosisHeadacheAnatomyV2 = (props: TPageProps) => (
  <DiagnosisQuestionTemplate
    {...props}
    currentSection={SECTION_NUMBER}
    titleI18nKey="onboarding.diagnosisHeadache.title"
    caseTextI18nKey="onboarding.diagnosisHeadache.caseText"
    options={[
      {
        key: 'temporalis',
        i18nKey: 'onboarding.diagnosisHeadache.options.temporalis',
      },
      {
        key: 'suboccipitals',
        i18nKey: 'onboarding.diagnosisHeadache.options.suboccipitals',
      },
      {
        key: 'masseter',
        i18nKey: 'onboarding.diagnosisHeadache.options.masseter',
      },
    ]}
    correctOptionKey={
      DIAGNOSIS_CORRECT_ANSWERS[PageId.DIAGNOSIS_HEADACHE_ANATOMY_V2_1]!
    }
    correctTitleI18nKey="onboarding.diagnosisHeadache.correctTitle"
    correctExplanationI18nKey="onboarding.diagnosisHeadache.correctExplanation"
    incorrectTitleI18nKey="onboarding.diagnosisHeadache.incorrectTitle"
    incorrectExplanationI18nKey="onboarding.diagnosisHeadache.incorrectExplanation"
    question="Diagnosis: headache case"
  />
)

export default DiagnosisHeadacheAnatomyV2
